import React, { useState } from 'react';
import axios from 'axios';

const config = { headers: { 'Content-Type': 'application/json' } };

const confirmAppointment = async (id, callback, error, method, checkboxVal) => {
    var response = await axios.post(`/${method}/approve/${id}`, checkboxVal, config);

    if (!response || !response.data.success) {
        error();
    }

    if (response.data.redirectUrl && response.data.redirectUrl.length) {
        window.location.replace(response.data.redirectUrl);
    }

    if (callback) {
        await callback();
    }
}

const cancelAppointment = async (id, callback, error, method, checkboxVal) => {
    var response = await axios.post(`/${method}/cancel/${id}`, checkboxVal, config);

    if (!response || !response.data.success)
        error();

    if (callback) {
        await callback();
    }
}

const ConfirmationButtons = (props) => {
    const { id, title, approveText, disapproveText, onClick, onCancelClick, error, callback, method, checkboxText, checkboxVal, checkboxOnClick, rescheduleText, changeAppointmentUrl, showSpinnerOnClick } = props;
    const [isBusy, setIsBusy] = useState(false);

    const run = async (action) => {
        if (!showSpinnerOnClick) {
            action();
            return;
        }

        setIsBusy(true);
        try {
            await action();
        } finally {
            setIsBusy(false);
        }
    }

    return (
        <div className="container">
            <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column">
                <div className="confirmationButtons_title">{title}</div>
                {isBusy ?
                    <div id="confirmation_buttons_spinner" className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">...</span>
                    </div>
                    :
                    <div>
                        <button id="confirm_btn" className="btn blue-btn text-white ms-1" onClick={() => run(() => { if (onClick) { onClick(); } return confirmAppointment(id, callback, error, method, checkboxVal); })}>{approveText}</button>
                        <button id="cancel_btn" className="btn light-blue-btn ms-1" onClick={() => run(() => cancelAppointment(id, onCancelClick, error, method, checkboxVal))}>{disapproveText}</button>
                        {changeAppointmentUrl && changeAppointmentUrl.length ?
                            <a id="change_btn" className="btn bordered-btn text-white" href={changeAppointmentUrl} title={rescheduleText}>{rescheduleText}</a> : null
                        }
                    </div>
                }
                {checkboxText ?
                    <label className="confirmationButtons_checkbox">
                        <input type="checkbox" value={checkboxVal} onClick={checkboxOnClick} />
                        <span className="checkmark"></span>
                        {checkboxText}
                    </label>
                    : null
                }
            </div>
        </div>
    );
}

export default ConfirmationButtons;
